import { Card, CardBody, Chip } from '@heroui/react';
import { useTranslation } from 'react-i18next';

export default function Solutions() {
  const { t } = useTranslation();
  const clientTypes = t('home.solutions.items', { returnObjects: true }) as Array<{
    eyebrow: string;
    title: string;
    description: string;
  }>;
  const icons = ['ri-store-2-line', 'ri-shopping-bag-3-line', 'ri-flow-chart', 'ri-settings-4-line'];

  return (
    <section className="relative z-10 overflow-hidden bg-transparent py-24 text-[#171717]">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 text-center md:mb-20">
          <Chip
            variant="flat"
            className="mb-5 border border-brand-green/20 bg-[rgba(255,255,255,0.82)] px-4 py-2 text-sm font-semibold text-brand-green shadow-[0_10px_25px_rgba(163,230,53,0.08)]"
            startContent={
              <span className="mr-2 inline-flex items-center">
                <i className="ri-user-search-line text-base" />
              </span>
            }
          >
            {t('home.solutions.badge')}
          </Chip>
          <h2 className="mb-6 text-5xl font-caprasimo text-[#111111] md:text-6xl">
            {t('home.solutions.title')}
          </h2>
          <p className="mx-auto max-w-3xl text-lg leading-relaxed text-[#536274] md:text-xl">
            {t('home.solutions.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {clientTypes.map((clientType, index) => (
            <div
              key={clientType.title}
              className="group h-full"
            >
              <Card className="h-full rounded-[28px] border border-[rgba(124,156,193,0.18)] bg-[rgba(255,255,255,0.72)] shadow-[0_16px_36px_rgba(91,126,168,0.08)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-green/35 hover:shadow-[0_26px_46px_rgba(83,121,166,0.14)]">
                <CardBody className="relative flex h-full flex-col gap-6 overflow-hidden p-7">
                  <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-green/45 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

                  <div className="flex items-center justify-between gap-4">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-green/15 text-brand-green shadow-[inset_0_1px_0_rgba(255,255,255,0.65)] transition-all duration-300 group-hover:bg-brand-green group-hover:text-[#0d0d0d]">
                      <i className={`${icons[index] ?? 'ri-user-search-line'} text-2xl`} />
                    </div>
                    <span className="rounded-full bg-brand-green/12 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#6d8a28]">
                      {clientType.eyebrow}
                    </span>
                  </div>

                  <div className="space-y-4">
                    <h3 className="text-[1.55rem] font-caprasimo leading-tight text-[#171717] transition-colors duration-300 group-hover:text-brand-green">
                      {clientType.title}
                    </h3>
                    <p className="text-sm leading-7 text-[#58697d] md:text-[15px]">
                      {clientType.description}
                    </p>
                  </div>

                  <div className="mt-auto flex items-center gap-2 pt-2 text-sm font-medium text-[#4f6072]">
                    <span className="transition-transform duration-300 group-hover:translate-x-1">
                      {t('home.solutions.cta')}
                    </span>
                    <i className="ri-arrow-right-up-line text-base text-brand-green transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
